export const qaStaging = {
  NEXT_PUBLIC_API_URL: 'https://agendapro-qa.com/api_views/workflow/v2',
  NEXT_PUBLIC_APRO_BASE_URL: 'https://app.agendapro-qa.com',
  NEXT_PUBLIC_AP_API_URL: 'https://ap-api.agendapro-qa.com',
  NEXT_PUBLIC_BACK_BASE_URL: 'https://agendapro-qa.com',
  NEXT_PUBLIC_BUSINESS_PROJECT_URL: 'https://business.agendapro.com',
  NEXT_PUBLIC_COOKIE_DOMAIN: 'agendapro-qa.com',
  NEXT_PUBLIC_CYPRESS_BASE_URL: 'http://lvh.me:8080',
  NEXT_PUBLIC_DEEP_LINKS_URL: '',
  NEXT_PUBLIC_DLOCAL_SMART_FIELD_URL: 'https://js-sandbox.dlocal.com',
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: 'clientes-agendapro.firebaseapp.com',
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: 'clientes-agendapro',
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: 'clientes-agendapro.appspot.com',
  NEXT_PUBLIC_FRONTEND_COOKIE: 'ap_authorization',
  NEXT_PUBLIC_HOTJAR_VERSION: '',
  SLS_ENVIRONMENT: 'qa',
};
